// src/Analytics.js
import { useEffect } from 'react';

export default function Analytics() {
  useEffect(() => {
    // Load GA script
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-J9PGF0MTYX';
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', 'G-J9PGF0MTYX');
  }, []);

  return null;
}